import React from "react";
import { Link, useNavigate } from "react-router-dom";
import {
  ConfirmationModal,
  TailwindToaster,
  Pagination,
} from "../../components";
import { toast } from "react-hot-toast";
import { useSelector } from "react-redux";

import axios from "../../api/axios";

const AddressBook = () => {
  const state = useSelector((state) => state.UserReducer);
  const navigate = useNavigate();
  const addressBookUrl = "/addressbook";

  const [refreshData, setRefreshData] = React.useState(true);
  const [addressBookData, setAddressBookData] = React.useState([]);
  const [addressBookServerData, setAddressBookServerData] = React.useState([]);
  const [currentPageIndex, setCurrentPageIndex] = React.useState(0);
  const [totalPages, setTotalPages] = React.useState(1);
  const [totalRecords, setTotalRecords] = React.useState(0);
  const [recordsPerPage, setRecordsPerPage] = React.useState(25);

  const getAddressBook = () => {
    try {
      axios
        .get(addressBookUrl, {
          headers: {
            "Content-Type": "application/json",
            Authorization: state.user.token,
            "Access-Control-Allow-Origin": "*",
          },
          params: {
            searchTerm,
            skip: currentPageIndex * recordsPerPage,
            limit: recordsPerPage,
          },
        })
        .then((response) => {
          if (response?.data?.addressBook?.length >= 0) {
            setAddressBookData(response.data.addressBook);
            setAddressBookServerData(response.data.addressBook);
            if (response.data.addressBookCount?.length > 0) {
              setTotalRecords(response.data.addressBookCount[0].addressBookCnt);
              setTotalPages(
                Math.ceil(
                  response.data.addressBookCount[0].addressBookCnt /
                    recordsPerPage,
                ),
              );
            } else {
              setTotalRecords(0);
              setTotalPages(0);
            }
          }
          setRefreshData(false);
        })
        .catch((err) => {
          toast.error("Something went wrong");
          setRefreshData(false);
        });
    } catch (err) {
      toast.error("Something went wrong");
      console.log(err);
      setRefreshData(false);
    }
  };

  const [deletePopupId, setDeletePopup] = React.useState(null);
  const deleteAddressBook = (addressBookId) => {
    setRefreshData(true);
    try {
      axios
        .delete(addressBookUrl + "/" + addressBookId, {
          headers: {
            "Content-Type": "application/json",
            Authorization: state.user.token,
          },
        })
        .then((response) => {
          if (response?.data?.status === "success") {
            toast.success(response?.data?.message);
            getAddressBook();
            setRefreshData(false);
          } else toast.error(response?.data?.message);
        })
        .catch((err) => {
          toast.error("Something went wrong");
          console.log(err);
        });
    } catch (err) {
      toast.error("Something went wrong");
      console.log(err);
    }
  };
  const confirmDelete = (addressBookId) => {
    setDeletePopup(addressBookId);
  };
  const closeConfirmation = () => {
    setDeletePopup(null);
  };
  const deleteConfirmation = (canDelete) => {
    if (canDelete) deleteAddressBook(deletePopupId);
    setDeletePopup(null);
  };

  const copyEmailToClipboard = (email) => {
    navigator.clipboard.writeText(email).then(() => {
      toast.success("Copied Email to Clipboard");
    });
  };

  const changePageCallback = (targetPageIndex) => {
    setCurrentPageIndex(targetPageIndex);
  };

  const changeDisplayRecordCountCallback = (targetRecordsPerPage) => {
    setRecordsPerPage(targetRecordsPerPage);
  };

  const [pageTitle, setPageTitle] = React.useState("Lands & Lands ERP");
  React.useEffect(() => {
    document.title = pageTitle;
  }, [pageTitle]);

  const [searchTerm, setSearchTerm] = React.useState("");

  // React.useEffect(() => {
  //   const delayDebounceFn = setTimeout(() => {
  //     console.log(searchTerm);
  //     getAddressBook();
  //   }, 500);

  //   return () => clearTimeout(delayDebounceFn);
  // }, [searchTerm]);

  React.useEffect(() => {
    setRefreshData(true);
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
    const delayDebounceFn = setTimeout(() => {
      getAddressBook();
    }, 500);
    setPageTitle("AddressBook - L&L ERP");
    return () => clearTimeout(delayDebounceFn);
  }, [recordsPerPage, currentPageIndex, searchTerm]);

  return (
    <>
      {deletePopupId && (
        <ConfirmationModal
          actionName={"Delete"}
          deleteConfirmation={deleteConfirmation}
          closeConfirmation={closeConfirmation}
          moduleName={"Delete Customer Record"}
          itemName={"AddressBook"}
        />
      )}
      <div className='min-h-full'>
        <main className='relative'>
          <div className='max-w-8xl mx-auto py-6 sm:px-6 lg:px-8'>
            <div className='lg:flex lg:items-center justify-between'>
              <div className='flex-1 min-w-0 px-5 lg:px-0'>
                <h2 className='mt-4 ml-1 text-xl font-semibold leading-7 text-gray-dark sm:text-xl '>
                  Address Book
                </h2>
              </div>
              <div className='flex mt-3 sm:ml-4 ml-5 sm:mr-0 mr-5'>
                <div className='grid grid-cols-4 gap-2 justify-items-end'>
                  <div className='col-span-3 w-full'>
                    <input
                      type='text'
                      name='search'
                      id='search'
                      onChange={(e) => {
                        setCurrentPageIndex(0);
                        setSearchTerm(e.target.value);
                      }}
                      placeholder='Search'
                      maxLength='20'
                      className='focus:ring-yellow-2 text-sm focus:border-yellow-2 block w-full shadow-sm sm:text-xs read-only:bg-gray-100 read-only:opacity-50 rounded-sm'
                    />
                  </div>
                  <div>
                    <span className=''>
                      <Link to='/addressbook/create'>
                        <button
                          type='button'
                          className='inline-flex items-center mt-.5 px-4 py-2 border border-gray-300 rounded-sm shadow-sm sm:text-xs text-sm font-medium text-black bg-yellow hover:bg-gray-dark hover:text-white focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500'>
                          Create
                        </button>
                      </Link>
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div className='px-4 py-6 sm:px-0'>
              <TailwindToaster />
              <div className='hidden md:block shadow-lg overflow-x-auto'>
                <table className='table-auto w-full shadow rounded-sm border-1 border-gray-dark'>
                  <thead className='bg-gray-50 border-b-2 border-yellow'>
                    <tr>
                      <th className='px-5 py-3 text-gray-dark text-sm font-semibold tracking-wide text-center'>
                        Customer&nbsp;Id
                      </th>
                      <th className='px-5 py-3 text-gray-dark text-sm font-semibold tracking-wide text-left'>
                        Customer&nbsp;Name
                      </th>
                      <th className='px-3 py-3 text-gray-dark text-sm font-semibold tracking-wide text-center'>
                        Mobile&nbsp;#
                      </th>
                      <th className='px-5 py-3 text-gray-dark text-sm font-semibold tracking-wide text-center'>
                        Email&nbsp;Id
                      </th>
                      <th className='px-5 py-3 text-gray-dark text-sm font-semibold tracking-wide text-center'>
                        Customer&nbsp;Type
                      </th>
                      <th className='px-5 py-3 text-gray-dark text-sm font-semibold tracking-wide text-center'>
                        CRM
                      </th>
                      <th
                        colSpan='2'
                        className='px-5 py-3 text-gray-dark text-sm font-semibold tracking-wide text-left'></th>
                    </tr>
                  </thead>
                  {!refreshData ? (
                    <tbody>
                      {addressBookData.length > 0 ? (
                        addressBookData.map((item, index) => (
                          // index >= currentPageIndex * recordsPerPage &&
                          // index < (currentPageIndex + 1) * recordsPerPage &&
                          <tr
                            key={item?.customerID}
                            className='hover:shadow-lg duration-300 cursor-default'>
                            <td
                              className='px-5 py-3 font-semibold text-sm tracking-wide text-center'
                              onClick={(e) => {
                                navigate(addressBookUrl + "/" + item?._id, {
                                  replace: false,
                                });
                              }}>
                              #{item?.customerID}
                            </td>
                            <td
                              className='px-3 py-3 font-normal text-xs tracking-wide text-left'
                              onClick={(e) => {
                                navigate(addressBookUrl + "/" + item?._id, {
                                  replace: false,
                                });
                              }}>
                              {item?.prefix}.&nbsp;{item?.firstName}
                              &nbsp;{item?.lastName ? item?.lastName : ""}
                            </td>
                            <td
                              className='px-2 py-3 font-normal text-xs tracking-wide text-center'
                              // onClick={(e) => {
                              //   navigate(addressBookUrl + "/" + item?._id, {
                              //     replace: false,
                              //   });
                              // }}
                            >
                              +{item?.countryCode.trim()}&nbsp;
                              {item?.phoneNumber}
                            </td>
                            <td
                              className='px-3 py-3 font-normal text-xs tracking-wide text-right'
                              onDoubleClick={(e) => {
                                navigate(addressBookUrl + "/" + item?._id, {
                                  replace: false,
                                });
                              }}>
                              <div className='grid grid-cols-6 gap-4'>
                                <div className='col-span-5 overflow-x-auto peer'>
                                  {item?.email
                                    ? item?.email.length > 25
                                      ? item?.email.slice(0, 15) +
                                        "..." +
                                        item?.email.slice(-7)
                                      : item?.email
                                    : "--"}
                                </div>
                                <div className='ml-0 opacity-0 peer-hover:opacity-100 hover:opacity-100 duration-300'>
                                  {item?.email ? (
                                    <>
                                      <svg
                                        xmlns='http://www.w3.org/2000/svg'
                                        className='h-5 w-5'
                                        fill='none'
                                        viewBox='0 0 24 24'
                                        stroke='currentColor'
                                        strokeWidth={2}
                                        onClick={() =>
                                          copyEmailToClipboard(item?.email)
                                        }>
                                        <path
                                          strokeLinecap='round'
                                          strokeLinejoin='round'
                                          d='M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2'
                                        />
                                      </svg>
                                    </>
                                  ) : (
                                    ""
                                  )}
                                </div>
                              </div>
                            </td>
                            <td
                              className='px-5 py-3 font-normal text-xs tracking-wide text-center'
                              onClick={(e) => {
                                navigate(addressBookUrl + "/" + item?._id, {
                                  replace: false,
                                });
                              }}>
                              {item?.customerType}
                            </td>
                            <td
                              className='px-5 py-3 font-normal text-xs tracking-wide text-center'
                              onClick={(e) => {
                                navigate(addressBookUrl + "/" + item?._id, {
                                  replace: false,
                                });
                              }}>
                              {item?.crm?.fullname && item?.crm?.fullname !== ""
                                ? item?.crm?.fullname
                                : item?.crm?.firstname}
                            </td>
                            {item?.createdBy === state.user._id ||
                            (state.user.department !== undefined &&
                              state.user.department?.name === "CRM") ||
                            ["admin", "super-admin"].includes(
                              state.user.aclGroup,
                            ) ? (
                              <td
                                onClick={(e) => {
                                  navigate(`/addressbook/edit/${item?._id}`, {
                                    replace: false,
                                  });
                                }}
                                className='px-5 py-3 text-sm font-semibold hover:bg-gray-100 text-yellow-2 text-right cursor-pointer'>
                                Edit
                              </td>
                            ) : (
                              <td
                                title={
                                  "Added by " + item?.createdBy?.fullname
                                }></td>
                            )}
                            {item?.createdBy === state.user._id ||
                            (state.user.department !== undefined &&
                              state.user.department?.name === "CRM") ||
                            ["admin", "super-admin"].includes(
                              state.user.aclGroup,
                            ) ? (
                              <td
                                onClick={() => {
                                  confirmDelete(item?._id);
                                }}
                                className='px-5 py-3 text-sm font-semibold hover:bg-gray-100 text-red-600 text-right cursor-pointer'>
                                Delete
                              </td>
                            ) : (
                              <td
                                title={
                                  "Added by " + item?.createdBy?.fullname
                                }></td>
                            )}
                          </tr>
                        ))
                      ) : (
                        <tr className='hover:shadow-lg'>
                          <td
                            className='px-5 py-3 font-normal text-sm tracking-wide text-center'
                            colSpan='5'>
                            No data available to display
                          </td>
                        </tr>
                      )}
                    </tbody>
                  ) : (
                    <tbody>
                      <tr>
                        <td className='px-5 py-3 font-normal text-sm tracking-wide text-center'>
                          <div className='flex animate-pulse flex-row items-center h-full justify-center'>
                            <div className='w-full bg-yellow-2 h-6 rounded-md '></div>
                          </div>
                        </td>
                        <td className='px-5 py-3 font-normal text-sm tracking-wide text-center'>
                          <div className='flex animate-pulse flex-row items-center h-full justify-center'>
                            <div className='w-full bg-yellow-2 h-6 rounded-md '></div>
                          </div>
                        </td>
                        <td className='px-5 py-3 font-normal text-sm tracking-wide text-center'>
                          <div className='flex animate-pulse flex-row items-center h-full justify-center'>
                            <div className='w-full bg-yellow-2 h-6 rounded-md '></div>
                          </div>
                        </td>
                        <td className='px-5 py-3 font-normal text-sm tracking-wide text-center'>
                          <div className='flex animate-pulse flex-row items-center h-full justify-center'>
                            <div className='w-full bg-yellow-2 h-6 rounded-md '></div>
                          </div>
                        </td>
                        <td className='px-5 py-3 font-normal text-sm tracking-wide text-center'>
                          <div className='flex animate-pulse flex-row items-center h-full justify-center'>
                            <div className='w-full bg-yellow-2 h-6 rounded-md '></div>
                          </div>
                        </td>
                        <td className='px-5 py-3 font-normal text-sm tracking-wide text-center'>
                          <div className='flex animate-pulse flex-row items-center h-full justify-center'>
                            <div className='w-full bg-yellow-2 h-6 rounded-md '></div>
                          </div>
                        </td>
                        <td
                          className='px-5 py-3 font-normal text-sm tracking-wide text-center'
                          colSpan='2'>
                          <div className='flex animate-pulse flex-row items-center h-full justify-center'>
                            <div className='w-full bg-yellow-2 h-6 rounded-md '></div>
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td className='px-5 py-3 font-normal text-sm tracking-wide text-center'>
                          <div className='flex animate-pulse flex-row items-center h-full justify-center'>
                            <div className='w-full bg-yellow-2 h-6 rounded-md '></div>
                          </div>
                        </td>
                        <td className='px-5 py-3 font-normal text-sm tracking-wide text-center'>
                          <div className='flex animate-pulse flex-row items-center h-full justify-center'>
                            <div className='w-full bg-yellow-2 h-6 rounded-md '></div>
                          </div>
                        </td>
                        <td className='px-5 py-3 font-normal text-sm tracking-wide text-center'>
                          <div className='flex animate-pulse flex-row items-center h-full justify-center'>
                            <div className='w-full bg-yellow-2 h-6 rounded-md '></div>
                          </div>
                        </td>
                        <td className='px-5 py-3 font-normal text-sm tracking-wide text-center'>
                          <div className='flex animate-pulse flex-row items-center h-full justify-center'>
                            <div className='w-full bg-yellow-2 h-6 rounded-md '></div>
                          </div>
                        </td>
                        <td className='px-5 py-3 font-normal text-sm tracking-wide text-center'>
                          <div className='flex animate-pulse flex-row items-center h-full justify-center'>
                            <div className='w-full bg-yellow-2 h-6 rounded-md '></div>
                          </div>
                        </td>
                        <td className='px-5 py-3 font-normal text-sm tracking-wide text-center'>
                          <div className='flex animate-pulse flex-row items-center h-full justify-center'>
                            <div className='w-full bg-yellow-2 h-6 rounded-md '></div>
                          </div>
                        </td>
                        <td
                          className='px-5 py-3 font-normal text-sm tracking-wide text-center'
                          colSpan='2'>
                          <div className='flex animate-pulse flex-row items-center h-full justify-center'>
                            <div className='w-full bg-yellow-2 h-6 rounded-md '></div>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  )}
                </table>
                {addressBookData.length > 0 && (
                  <Pagination
                    pages={totalPages}
                    currentPage={currentPageIndex}
                    recordsPerPage={recordsPerPage}
                    changePageCallback={changePageCallback}
                    totalRecords={totalRecords}
                    changeDisplayRecordCountCallback={
                      changeDisplayRecordCountCallback
                    }
                  />
                )}
              </div>
              <div className='block md:hidden'>
                {!refreshData ? (
                  <div className='grid grid-cols-1 gap-1'>
                    {addressBookData.length > 0 ? (
                      <div className=''>
                        {addressBookData.map((item) => (
                          <div
                            key={item?.customerID}
                            className='px-1 py-1 shadow border-b-2 border-gray-100'>
                            <div className='grid grid-cols-6'>
                              <div
                                className='col-span-4'
                                onClick={(e) => {
                                  navigate(addressBookUrl + "/" + item?._id, {
                                    replace: false,
                                  });
                                }}>
                                <div className='flex flex-col'>
                                  <div>
                                    <h4 className='text-gray-dark font-semibold text-sm tracking-wide pl-2 pt-1'>
                                      #{item?.customerID} | {item?.customerType}
                                    </h4>
                                  </div>
                                  <div
                                    onClick={(e) => {
                                      navigate(
                                        addressBookUrl + "/" + item?._id,
                                        {
                                          replace: false,
                                        },
                                      );
                                    }}>
                                    <h4 className='text-gray-dark font-normal text-sm tracking-wide pl-2 pt-1 text-left'>
                                      {item?.prefix}.&nbsp;
                                      {item?.firstName}&nbsp;
                                      {item?.lastName ? item?.lastName : ""}
                                    </h4>
                                  </div>
                                  <div
                                    onClick={(e) => {
                                      navigate(
                                        addressBookUrl + "/" + item?._id,
                                        {
                                          replace: false,
                                        },
                                      );
                                    }}>
                                    <div>
                                      <h4 className='text-gray-dark font-normal text-sm tracking-wide pl-2 pt-0 text-left'>
                                        {"" + item?.countryCode}&nbsp;
                                        {item?.phoneNumber}
                                      </h4>
                                    </div>
                                  </div>
                                  <div className='text-gray-dark font-normal text-sm tracking-wide pl-2 pt-0 text-left'>
                                    {item?.email
                                      ? item?.email.length > 25
                                        ? item?.email.slice(0, 15) +
                                          "..." +
                                          item?.email.slice(-7)
                                        : item?.email
                                      : "--"}
                                  </div>
                                </div>
                              </div>
                              <div className='col-span-2'>
                                <div className='flex flex-col'>
                                  <div
                                    onClick={(e) => {
                                      navigate(
                                        addressBookUrl + "/" + item?._id,
                                        {
                                          replace: false,
                                        },
                                      );
                                    }}>
                                    <h4 className='text-gray-dark font-bold text-xs tracking-wide pr-2 pt-1 text-right'>
                                      {item?.crm?.fullname &&
                                      item?.crm?.fullname !== ""
                                        ? item.crm.fullname
                                        : item?.crm?.firstname}
                                    </h4>
                                  </div>
                                </div>
                              </div>
                              <div className='col-span-3'></div>
                              <div className='col-span-6'>
                                {item?.createdBy === state.user._id ||
                                  (state.user.department !== undefined &&
                                    state.user.department?.name === "CRM") ||
                                  (["admin", "super-admin"].includes(
                                    state.user.aclGroup,
                                  ) && (
                                    <div className='pb-1 pr-3 right-0'>
                                      <div className='grid grid-cols-6 gap-2'>
                                        <div className='col-span-4'></div>
                                        <div className=''>
                                          <Link
                                            to={`/addressbook/edit/${item?._id}`}>
                                            <h4 className='font-semibold text-base text-yellow-2 text-right pr-2'>
                                              Edit
                                            </h4>
                                          </Link>
                                        </div>
                                        <div className=''>
                                          <h4
                                            onClick={() => {
                                              confirmDelete(item?._id);
                                            }}
                                            className='font-semibold text-base text-red-600 text-right pr-2'>
                                            Delete
                                          </h4>
                                        </div>
                                      </div>
                                    </div>
                                  ))}
                              </div>
                            </div>
                          </div>
                        ))}
                        {addressBookData.length > 0 && (
                          <Pagination
                            pages={totalPages}
                            currentPage={currentPageIndex}
                            recordsPerPage={recordsPerPage}
                            changePageCallback={changePageCallback}
                            totalRecords={totalRecords}
                            changeDisplayRecordCountCallback={
                              changeDisplayRecordCountCallback
                            }
                          />
                        )}
                      </div>
                    ) : (
                      <div className='px-3 py-2'>
                        <h4 className='text-lg font-semibold'>
                          No data to display
                        </h4>
                      </div>
                    )}
                  </div>
                ) : (
                  <div className='grid grid-cols-1 gap-4 '>
                    <div className='flex animate-pulse flex-col items-left h-full justify-center border-b-2 pb-1 border-gray-100'>
                      <div className='flex flex-row gap-2'>
                        <div className='w-5/12 bg-yellow-2 h-6 rounded-md '></div>
                        <div className='w-7/12 bg-gray-200 h-6 rounded-md '></div>
                      </div>
                      <div className='w-full bg-gray-100 h-4 rounded-md mt-2 '></div>
                      <div className='w-full bg-gray-100 h-4 rounded-md mt-2 '></div>
                      <div className='flex flex-row gap-2 mt-2'>
                        <div className='w-8/12 bg-gray-100 h-8 rounded-md '></div>
                        <div className='w-4/12 bg-yellow-2 h-8 rounded-md '></div>
                      </div>
                    </div>
                    <div className='flex animate-pulse flex-col items-left h-full justify-center mt-1 border-b-2 pb-1 border-gray-100'>
                      <div className='flex flex-row gap-2'>
                        <div className='w-5/12 bg-yellow-2 h-6 rounded-md '></div>
                        <div className='w-7/12 bg-gray-200 h-6 rounded-md '></div>
                      </div>
                      <div className='w-full bg-gray-100 h-4 rounded-md mt-2 '></div>
                      <div className='w-full bg-gray-100 h-4 rounded-md mt-2 '></div>
                      <div className='flex flex-row gap-2 mt-2'>
                        <div className='w-8/12 bg-gray-100 h-8 rounded-md '></div>
                        <div className='w-4/12 bg-yellow-2 h-8 rounded-md '></div>
                      </div>
                    </div>
                    <div className='flex animate-pulse flex-col items-left h-full justify-center mt-1 border-b-2 pb-1 border-gray-100'>
                      <div className='flex flex-row gap-2'>
                        <div className='w-5/12 bg-yellow-2 h-6 rounded-md '></div>
                        <div className='w-7/12 bg-gray-200 h-6 rounded-md '></div>
                      </div>
                      <div className='w-full bg-gray-100 h-4 rounded-md mt-2 '></div>
                      <div className='w-full bg-gray-100 h-4 rounded-md mt-2 '></div>
                      <div className='flex flex-row gap-2 mt-2'>
                        <div className='w-8/12 bg-gray-100 h-8 rounded-md '></div>
                        <div className='w-4/12 bg-yellow-2 h-8 rounded-md '></div>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </main>
      </div>
    </>
  );
};

export default AddressBook;
